if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = event.target

        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        })
      })
    }

    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('input:checked')).map(
        ({ dataset }) => dataset.optionValueId,
      )
    }
  }
  customElements.define('variant-selects', VariantSelects)
}
